import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import englishMessages from './locales/en.json'

export const DEFAULT_LANGUAGE = 'en'

/** Add a language here only after its locale file contains every key of `en.json`. */
export const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const resources = {
  en: { translation: englishMessages },
} as const satisfies Record<SupportedLanguage, { translation: typeof englishMessages }>

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  defaultNS: 'translation',
  // Resources are bundled, so initialise synchronously and avoid a first render without texts.
  initAsync: false,
  interpolation: {
    // React already escapes rendered strings.
    escapeValue: false,
  },
})

/** Language sent to the backend in the `X-Language` header so error messages match the UI. */
export function getCurrentLanguage(): string {
  return i18n.resolvedLanguage ?? DEFAULT_LANGUAGE
}

export { i18n }
